import React from "react";
import { Heart, ShoppingCart } from "lucide-react";

const FAVS = [
  { name: "Aceite Abundancia Divina", maker: "Aroma de Luz", price: "$ 45.000 COP", img: "https://images.unsplash.com/photo-1610631066894-62452ccb927c?auto=format&fit=crop&w=800&q=80" },
  { name: "Estudio Egipcio", maker: "Maestra Inanna", price: "$ 450.000 COP", img: "https://images.unsplash.com/photo-1568322445389-f64ac2515020?auto=format&fit=crop&w=800&q=80" },
  { name: "Vela Protección y Luz", maker: "Luz Violeta", price: "$ 38.000 COP", img: "https://images.unsplash.com/photo-1607344645866-009c320c5ab8?auto=format&fit=crop&w=800&q=80" },
  { name: "Curso Geometría Sagrada", maker: "Academia KD9", price: "$ 180.000 COP", img: "https://images.unsplash.com/photo-1518972559570-7cc1309f3229?auto=format&fit=crop&w=800&q=80" },
];

const Favoritos = () => (
  <div data-testid="favoritos-page">
    <header className="mb-8">
      <div className="font-mont text-[11px] tracking-[0.4em] uppercase mb-2" style={{ color: "var(--kd9-gold)" }}>· Tus Favoritos ·</div>
      <h1 className="font-cinzel kd9-gold-text text-3xl md:text-4xl tracking-[0.06em] mb-3">
        <Heart className="inline mr-3" fill="#D4AF37" style={{ color: "var(--kd9-gold)" }} /> MIS FAVORITOS
      </h1>
      <p className="font-cormorant text-lg" style={{ color: "var(--kd9-text-soft)" }}>
        Productos, estudios y cursos que has guardado para más tarde.
      </p>
    </header>

    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
      {FAVS.map((f, i) => (
        <article key={f.name} className="kd9-card overflow-hidden" data-testid={`fav-${i}`}>
          <div className="relative h-44">
            <img src={f.img} alt={f.name} className="w-full h-full object-cover" />
            <button className="absolute top-3 right-3 w-9 h-9 rounded-full flex items-center justify-center" style={{ background: "rgba(212,175,55,0.95)" }}>
              <Heart size={14} fill="#0a0a0a" style={{ color: "#0a0a0a" }} />
            </button>
          </div>
          <div className="p-4">
            <h4 className="font-cinzel kd9-gold-text text-base tracking-[0.04em] mb-1">{f.name}</h4>
            <div className="text-[11px] font-mont mb-3" style={{ color: "var(--kd9-text-soft)" }}>Por {f.maker}</div>
            <div className="flex items-center justify-between mb-3">
              <div className="font-cinzel kd9-gold-text">{f.price}</div>
            </div>
            <button className="kd9-btn-gold w-full py-2.5 rounded-lg text-[10px] flex items-center justify-center gap-2">
              <ShoppingCart size={12} /> Agregar
            </button>
          </div>
        </article>
      ))}
    </div>
  </div>
);

export default Favoritos;
